module.exports = __webpack_public_path__ + "static/economy-chart.0d21b8ec.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/economy-chart.png
// module id = 281
// module chunks = 3